import React from 'react';
import { useAuth } from './hooks/useAuth';
import { Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  
  return isAuth ? (
    <Outlet />
  ) : (
    window.location.replace('/')
  );
};

export default ProtectedRoutes;
